import {useState, useEffect} from 'react';

const About = () => {

    const [years, setYears] = useState(0);

useEffect(()=>{
const currentYear = new Date().getFullYear();
const start = new Date("2019-09-13").getFullYear();
const yearsPast = currentYear - start;
setYears(yearsPast);

}, []);
    return (
        <section id="about" className="relative overflow-hidden h-screen w-full my-8">
        <div id="about-section-background" className=" absolute top-0 w-full h-full">


        </div>
            <div id="about-video-container" className="w-full h-full rounded-tl-2xl ">
                <video className="h-full w-full object-cover rounded-full"  muted loop autoPlay>
                    <source src="videos/artem-podrez-pixels-laptop-video.mp4" type="video/mp4"/>
                    <div className="h-full w-full bg-white bg-opacity-50 ">

                    </div>
                </video>
            </div>

            <div id="about-me-desc-container" className="absolute top-0 flex flex-col justify-center items-center w-4/5 h-full p-4 sm-max:w-full sm-max:p-1 lg-min:w-full ">

                <div id="circle" className="absolute top-0 left-0 rounded-tr-full rounded-br-full rounded-bl-full bg-white w-1/2 h-1/2 "></div>

                <div  className="w-full h-full absolute top-0 py-8 px-4 sm-max:p-1">
                    <p className="mb-4 text-lg text-customblue  sm-max:text-sm ">My name is Yanick and I have always enjoyed using all kinds of software and occassionally trying to fix broken hardware. Even if I had no idea of what I was doing I would still get into it. </p>
                    <p className="mb-4 text-lg text-customblue  sm-max:text-sm
                     ">In September 2019, I learned that building software is not as difficult as I believed it to be. Thereafter, I joined <span><a className="text-lg text-customyellow hover:text-customdarkblue focus:text-customyellow cursor-pointer " href="https://www.thetrainingroom.com/" rel="noopener noreferrer" target="_blank">The Training Room</a></span> and learned HTML5, CSS3 and JAVASCRIPT. I was also introduced to Java, SQL and Python. With this, I already started to experiment on building things on the web.</p>
                    <p className="mb-4 text-lg text-customblue  sm-max:text-sm  ">Since then, it has been {years} years and I have gain even more knowledge on sofware development and learnt a few more languages and libraries just to name a few below.</p>

                    <div className="flex flex-row w-full">
                        <ul className="list-none grid grid-cols-2 p-2 w-full sm-max:grid-cols-3 ">
                            <div className="w-1/2 mb-2 sm-max:w-full">
                                <li className="flex items-center text-customblue text-lg " ><i className="fab fa-react mr-4 text-2xl font-bold text-customyellow "></i>React</li>
                            </div>
                            <div className="w-1/2 mb-2 sm-max:w-full">
                                <li className="flex items-center text-customblue text-lg " ><i className="fab fa-java mr-4 text-2xl font-bold text-customyellow "></i>Java</li>
                            </div>
                            <div className="w-1/2 mb-2 sm-max:w-full">
                                <li className="flex items-center text-customblue text-lg " ><i className="fab fa-python mr-4 text-2xl font-bold text-customyellow "></i>Python</li>
                            </div>
                            <div className="w-1/2 mb-2 sm-max:w-full">
                                <li className="flex items-center text-customblue text-lg " ><i className="fas fa-code mr-4 text-2xl font-bold text-customyellow "></i>SQL</li>
                            </div>
                            <div className="w-1/2 mb-2 sm-max:w-full">
                                <li className="flex items-center text-customblue text-lg " ><i className="fab fa-php mr-4 text-2xl font-bold text-customyellow "></i>PHP</li>
                            </div>
                        </ul>
                    </div>
                </div>
               
            </div>
        </section>
    );
};


export default About;